import AssetsCoin from '@/assets/image/useCases/digitalAssets/AssetsCoin.png'
import '@/assets/scss/global.scss';
import './index.scss'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const PrivateCreditFoot = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
   return (
     <div className='private-credit-foot'>
       {
         isDesktop ? (
           <div className={`w-1340 pt-[214px] private-credit-foot-item pl-[192px] pb-[140px] pr-[192px] text-[#fff] text-left flex items-start justify-center`}>
             <div>
               <div className={`private-credit-foot-title text-[64px]`}>
                 $350,000,000
               </div>
               <div className={`private-credit-foot-desc pb-[30px] text-[18px]`}>
                 in committed BTC liquidity from $200B pool
               </div>
               <div className={`get-touch-btn`}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
             <div className={`flex items-center ml-[24px] mt-[-74px]`}>
               <img src={AssetsCoin} className={`h-[150px]`} />
             </div>
           </div>
         ) : (
           <div
             className={`w-1340 pt-[80px] private-credit-foot-item pb-[80px] text-[#fff] text-left`}>
             <div className={`flex justify-center mb-[40px]`}>
               <img src={AssetsCoin} className={`h-[150px]`} />
             </div>
             <div className={`text-center`}>
               <div className={`private-credit-foot-title text-[20px] pb-[20px]`}>
                 $350,000,000
               </div>
               <div className={`private-credit-foot-desc pb-[20px] text-[14px]`}>
                 in committed BTC liquidity from $200B pool
               </div>
               <div className={`get-touch-btn`} style={{margin:'0 auto'}}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
           </div>
         )
       }
     </div>
   )
}

export default PrivateCreditFoot